// Module
var code = "<div class=\"gc-close\" @click=\"stop({ event: $event })\"></div>";
// Exports
export default code;